import * as React from 'react';

import { connectionSelector } from 'src/selectors/connection';
import {
  ConnectionFailureReason,
  ConnectionStatus,
} from 'src/store/connections/types';
import { usePrevious } from 'src/utils/hooks/usePrevious';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { warnWebProtocolInconsistencies } from 'src/utils/web/warnWebProtocolInconsistencies';

export const useAlertWebProtocolInconsistencies = () => {
  // if connection failed due to no response, alert that it's possibly due
  // to http/https protocol inconsistencies
  const connection = useReduxSelector(connectionSelector);
  const status = useReduxSelector((state) => state.connections.status);
  const prevStatus = usePrevious(status);
  const failureReason = useReduxSelector(
    (state) => state.connections.failureReason
  );
  React.useEffect(() => {
    if (
      connection?.endpoint &&
      prevStatus === ConnectionStatus.PENDING &&
      status === ConnectionStatus.FAILURE &&
      failureReason === ConnectionFailureReason.NO_RESPONSE
    ) {
      warnWebProtocolInconsistencies(connection.endpoint);
    }
  }, [connection, failureReason, prevStatus, status]);
};
